import { isEmpty, isNull, isUndefined } from "lodash";
import { updateVariableValue } from "../hooks/variableManager";
import {
    AGENT_PRE_CALL_NETWORK_TEST_LINK,
    PARAMS,
    SHOWME_BACKGROUND_COLOR,
    NETWORK,
    USER_TYPES,
    SUPPORT_OPTION,
    PLATFORM,
    ENGLISH_LANGUAGE_CODES,
    DEVICETYPE,
} from "../constants/Constants";
import DetectRTC from "detectrtc";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";
import { getDomainURL, getExactBrowserName, goToPlayStore } from "./utility";
import NavigatorService from "../services/navigatorService";
import { LogFirebase } from "../services/firestore";
import { setAskUserPopup } from "../reducers/common-reducer";
import { HELP_ARTICLE } from "../constants/LDConstants";
import { JAPAN_LANGUAGE_CODE, POLAND_LANGUAGE_CODE } from "../constants/LanguageConstants";

export const FilterObjectByArrayOfKeys = (obj, arr) => {
    /* Filtering out key-value pairs with keys in the arr */
    const filteredObject = Object.fromEntries(Object.entries(obj).filter(([key, value]) => !arr.includes(key)));

    return filteredObject;
};

export const getValidSessionID = (code) => {
    let validSessionID = "";
    if (!isUndefined(code) || !isNull(code)) {
        validSessionID = code.replace(/[^0-9\.]+/g, "");
    }
    return validSessionID.substring(0, 9);
};

export const allowOnlyNumericInput = (event) => {
    const keyCode = event.keyCode || event.charCode;
    // Check if the pressed key is a number (0-9)
    if (keyCode >= 48 && keyCode <= 57) {
        // Allow the key press
        return true;
    }
};

export const formatSessionID = (num) => {
    if (num == undefined || num == null || num === "") {
        return "";
    }
    // Normalize string and remove all unnecessary characters
    num = num.replace(/[^\d]/g, "");

    // Check if the number length equals 10
    if (num.length < 3) {
        // Reformat and return num number
        return num.replace(/(\d{})/, "");
    } else if (num.length > 3 && num.length <= 6) {
        // Reformat and return num number
        return num.replace(/(\d{3})/, "$1-");
    } else if (num.length == 7 || num.length == 8) {
        // Reformat and return num number
        return num.replace(/(\d{3})(\d{3})/, "$1-$2-");
    } else if (num.length >= 9) {
        // Reformat and return num number
        return num.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3");
    }
    return num;
};

export const setSCSSVariables = (brandingColors) => {
    if (brandingColors?.hasOwnProperty("page_background_color")) {
        const root = document.querySelector(":root");
        for (let prop in brandingColors) {
            if (prop == "tabbar_fill_color" && brandingColors[prop].toLowerCase().substring(0, 4) == "#fff") {
                const element = document.getElementsByTagName("body")[0];
                if (element) {
                    element.classList.add("white-theme");
                }
            }
            root.style.setProperty("--" + prop, brandingColors[prop]);
        }
    } else {
        setShowLoading(false);
    }
};

export const setShowMeBackground = () => {
    let root = document.querySelector(":root");
    root.style.setProperty("--page_background_color", SHOWME_BACKGROUND_COLOR);
    const loader = document.getElementById("page-loader");
    if (loader) {
        loader.classList?.add("page-loader-hide");
    }
};

/**
 * Checks if the speed test link should be available based on user information and branding flags.
 * @param {string} GLOBAL_MEETING_DATA.ucid - User ID used for checking availability of Agent.
 * @param {object} companyFooterInfo - Information from the company's API.
 * @param {object} privacyPolicyFooterInfo - Information from the privacy policy's API.
 * @returns {object} An object indicating if the speed test link is visible and the corresponding HTML.
 */
export const isSpeedTestLinkAvailable = (companyFooterInfo, privacyPolicyFooterInfo, keepBlitzzBranding, localisedValues) => {
    if (GLOBAL_MEETING_DATA.ucid) {
        if (!keepBlitzzBranding) {
            GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData = {
                isVisible: false,
                footerHtml: null,
                waitingScreenLinkHtml: null,
            };
            return GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData;
        }
        // If the user is an agent and branding flag is true, show the speed test link
        GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData = {
            isVisible: true,
            footerHtml: (
                <div className='call-footer-box'>
                    <a className='for-link' href={AGENT_PRE_CALL_NETWORK_TEST_LINK} target='_blank'>
                        {localisedValues?.pre_call_test}
                    </a>
                </div>
            ),
            waitingScreenLinkHtml: (
                <div className='call-progress-link'>
                    <a className='btn btn-link' href={AGENT_PRE_CALL_NETWORK_TEST_LINK} target='_blank'>
                        {localisedValues?.pre_call_test}
                    </a>
                </div>
            ),
        };
        return GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData;
    } else if (!GLOBAL_MEETING_DATA.ucid) {
        if (privacyPolicyFooterInfo?.isFooterVisible) {
            // If privacy policy footer is visible, show the corresponding link
            GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData = {
                isVisible: true,
                footerHtml: (
                    <div className='call-footer-box'>
                        <a className='for-link' href={privacyPolicyFooterInfo.footerURL} target='_blank'>
                            {privacyPolicyFooterInfo.footerText}
                        </a>
                    </div>
                ),
                waitingScreenLinkHtml: (
                    <div className='call-progress-link'>
                        <a className='btn btn-link' href={privacyPolicyFooterInfo.footerURL} target='_blank'>
                            {privacyPolicyFooterInfo.footerText}
                        </a>
                    </div>
                ),
            };
            return GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData;
        } else if (companyFooterInfo?.isFooterVisible) {
            // If company footer is visible, show the corresponding link
            GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData = {
                isVisible: true,
                footerHtml: (
                    <div className='call-footer-box'>
                        <a className='for-link' href={companyFooterInfo.footerURL} target='_blank'>
                            {companyFooterInfo.footerText}
                        </a>
                    </div>
                ),
                waitingScreenLinkHtml: (
                    <div className='call-progress-link'>
                        <a className='btn btn-link' href={companyFooterInfo.footerURL} target='_blank'>
                            {companyFooterInfo.footerText}
                        </a>
                    </div>
                ),
            };
            return GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData;
        } else {
            // If no footer is visible, return false
            GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData = {
                isVisible: false,
                footerHtml: null,
            };
            return GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData;
        }
    }
};

/**
 * Checks if the "Powered By" feature is available based on the presence of a user ID (ucid)
 * and the company's "Powered By" status.
 * @param {string} ucid - User ID used for checking availability.
 * @param {boolean} isCompanyPoweredBy - Company's "Powered By" status.
 * @returns {boolean} True if the "Powered By" feature is available, otherwise false.
 */
export const isPoweredByAvailable = (isCompanyPoweredBy) => {
    // Check if there is no user ID and the company has enabled the "Powered By" feature
    if (!GLOBAL_MEETING_DATA.ucid && isCompanyPoweredBy) {
        GLOBAL_MEETING_DATA.getIsPoweredByAvailable = true;
        return true; // "Powered By" is available
    } else {
        GLOBAL_MEETING_DATA.getIsPoweredByAvailable = false;
        return false; // "Powered By" is not available
    }
};

export const handleSupportOptionForMobileBrowser = (dispatch) => {
    if (PublicVariables.isMobile) {
        if (GLOBAL_MEETING_DATA.smsSupportOption == SUPPORT_OPTION.APP_ONLY) {
            //use APP only
            goToPlayStore();
        } else if (GLOBAL_MEETING_DATA.smsSupportOption == SUPPORT_OPTION.ASK_USER) {
            //Ask end User
            // countinue with web
            dispatch(setAskUserPopup(true)); // ask user countinue with APP or Web
        }
    }
};

/**
 * Determines the user type based on the presence of a parameter in the URL search and set in PublicVariables.
 */
export const setUserType = (dispatch) => {
    // Extracting search parameters from the current window's location
    const searchParams = new URLSearchParams(window.location.search);

    // Check if the parameter is present to determine user type
    GLOBAL_MEETING_DATA.isAgent = searchParams.has(PARAMS.AGENT);
    GLOBAL_MEETING_DATA.isGuest = !GLOBAL_MEETING_DATA.isAgent; // Assuming a user is either an agent or a guest
    if (searchParams.has(PARAMS.AGENT)) {
        GLOBAL_MEETING_DATA.ucid = searchParams.get(PARAMS.AGENT); // set ucid in global data if the user is agent
    }
    if (searchParams.has(PARAMS.PID)) {
        GLOBAL_MEETING_DATA.pid = searchParams.get(PARAMS.PID); // set pidin global data if pid is in url
    }
    if (searchParams.has(PARAMS.SUPPORT_OPTION)) {
        if (!GLOBAL_MEETING_DATA.isAgent) {
            GLOBAL_MEETING_DATA.smsSupportOption = searchParams.get(PARAMS.SUPPORT_OPTION);
            handleSupportOptionForMobileBrowser(dispatch);
        } else {
            GLOBAL_MEETING_DATA.smsSupportOption = SUPPORT_OPTION.BROWSER_FIRST;
        }
    }
    CALL_DATA.isObserver = searchParams.has(PARAMS.OBSERVER);
    /* Set user type based on parameters */

    if (GLOBAL_MEETING_DATA.isAgent) {
        GLOBAL_MEETING_DATA.userType = USER_TYPES.AGENT;
    } else if (CALL_DATA.isObserver) {
        GLOBAL_MEETING_DATA.userType = USER_TYPES.SILENT_OBSERVER;
    } else {
        GLOBAL_MEETING_DATA.userType = USER_TYPES.GUEST;
    }

    if (searchParams.has(PARAMS.CLOSE_TAB)) {
        if (!isEmpty(searchParams.get(PARAMS.CLOSE_TAB))) {
            const paramsVal = searchParams.get(PARAMS.CLOSE_TAB);
            let closeTabDecodeValue = decodeURIComponent(paramsVal);
            GLOBAL_MEETING_DATA.closetabParams = closeTabDecodeValue;
        }
    }
    if (searchParams.has(PARAMS.PLATFORM)) {
        if (!isEmpty(searchParams.get(PARAMS.PLATFORM))) {
            const paramsVal = searchParams.get(PARAMS.PLATFORM);
            let platFormDecodeValue = decodeURIComponent(paramsVal);
            GLOBAL_MEETING_DATA.platformParams = platFormDecodeValue;
        }
    }
    if (searchParams.has(PARAMS.REDIRECT_URL)) {
        if (!isEmpty(searchParams.get(PARAMS.REDIRECT_URL))) {
            const redirectVal = searchParams.get(PARAMS.REDIRECT_URL);
            let redirectDecodeValue = decodeURIComponent(redirectVal);
            GLOBAL_MEETING_DATA.redirectParams = redirectDecodeValue;
        }
    }
    if (searchParams.has(PARAMS.HOME_SCREEN_BUTTON)) {
        if (!isEmpty(searchParams.get(PARAMS.HOME_SCREEN_BUTTON))) {
            const homeScreenButtonVal = searchParams.get(PARAMS.HOME_SCREEN_BUTTON);
            let homeScreenButtonDecodeValue = decodeURIComponent(homeScreenButtonVal);
            GLOBAL_MEETING_DATA.homeScreenButtonParams = Number(homeScreenButtonDecodeValue);
        }
    }
    if (searchParams.has(PARAMS.LOG)) {
        GLOBAL_MEETING_DATA.isRoomCallHasLogsParams = searchParams.get(PARAMS.LOG);
    }
};

export const isThirdPartyPlatform = () => {
    const platformName = GLOBAL_MEETING_DATA.platformParams;
    return (
        !isEmpty(platformName?.toLowerCase()) &&
        (platformName?.toLowerCase() == PLATFORM.ZENDESK.toLowerCase() ||
            platformName?.toLowerCase() == PLATFORM.SALESFORCE.toLowerCase() ||
            platformName?.toLowerCase() == PLATFORM.SERVICENOW.toLowerCase() ||
            platformName?.toLowerCase() == PLATFORM.HUBSPOT.toLowerCase())
    );
};

export const isIFrame = () => {
    return window.location !== window.parent.location; /* Check whether URL is in IFrame or not */
};

export const isCustomDomain = () => {
    const domainName = getDomainURL();
    GLOBAL_MEETING_DATA.isCustomDomain = domainName !== null;
    return domainName !== null;
};

export const setShowLoading = (isShowLoading) => {
    const loader = document.getElementById("page-loader");
    if (loader) {
        if (isShowLoading) {
            loader.classList?.remove("page-loader-hide");
        } else {
            loader.classList?.add("page-loader-hide");
        }
    }
};

/* Generate and return dynamic state object using given key name for any state used in reducer */
export const createObjectForStates = (key) => {
    const stateObject = {};
    stateObject[key + "Loading"] = false;
    stateObject[key + "Data"] = false;
    stateObject[key + "Error"] = false;

    return stateObject;
};

/* Generate and return dynamic Action events object using given key name for any Event defined for reducer */
export const createActionTypeObject = (key) => {
    return {
        START: key + "_START",
        SUCCESS: key + "_SUCCESS",
        ERROR: key + "_ERROR",
    };
};

/* Generate response action object */
export const dispatchAction = (event, type, payload) => {
    const responseAction = {
        event: event,
        type: type,
    };

    if (payload) {
        responseAction.payload = payload;
    }

    return responseAction;
};

/* return updated state object for given keys with value new values for respected received event */
export const getUpdatedState = (key, action, actionType, actionPayload) => {
    const updatedStateObject = {};
    updatedStateObject[key + "Loading"] = actionType === action.START;
    updatedStateObject[key + "Data"] = actionType === action.SUCCESS ? actionPayload : false;
    updatedStateObject[key + "Error"] = actionType === action.ERROR ? actionPayload : false;
    return updatedStateObject;
};

export const deviceDetailsRequestParams = (request) => {
    request.latitude = CALL_DATA.Latitude ? CALL_DATA.Latitude : 0;
    request.longitude = CALL_DATA.Longitude ? CALL_DATA.Longitude : 0;
    request.networkType = CALL_DATA.callstatsNetType === NETWORK.Unknown ? null : CALL_DATA?.callstatsNetType?.toUpperCase();
    request.networkSpeed = CALL_DATA.callstatsNetSpeed === "N/A" ? null : CALL_DATA?.callstatsNetSpeed?.toUpperCase();
    request.os = DetectRTC.osName;
    request.osVersion = DetectRTC.osVersion;
    request.deviceType = DEVICETYPE; // this is for the Web only

    const browserInfo = getExactBrowserName();
    request.browser = browserInfo?.browserName;
    request.browserVersion = browserInfo?.browserVersion;

    request.displayResolution = NavigatorService.displayResolution();
    request.deviceModel = null;
    const userAgent = navigator.userAgent;

    if (userAgent) {
        const start = userAgent?.indexOf("(") + 1;
        const end = userAgent?.indexOf(")");

        if (start > 0 && end > start) {
            const platformInfo = userAgent?.substring(start, end);
            const platformParts = platformInfo?.split(";");

            const deviceModel = platformParts[platformParts?.length - 1]?.trim();
            request.deviceModel = deviceModel || null;
        } else {
            request.deviceModel = null;
        }
    }

    request.deviceBrand = null;
    request.cpu = null;
    request.cpuClockSpeed = null;
    request.memoryCapacity = null;
    request.memoryUsed = null;
    request.memoryFree = null;
    request.appVersion = null;
    request.storageCapacity = null;
    request.storageUsed = null;
    request.storageFree = null;
    request.networkProvider = null;
    // Utility function to extract device labels
    const extractDeviceLabels = (devices) =>
        devices
            .filter((device) => device.label !== null)
            .map((device) => device.label)
            .join(", ");

    request.microPhone = extractDeviceLabels(DetectRTC.audioInputDevices);
    request.speaker = extractDeviceLabels(DetectRTC.audioOutputDevices);
    request.camera = extractDeviceLabels(DetectRTC.videoInputDevices);

    request.memoryCapacity = NavigatorService.getDeviceMemory();
    // console.log("request__data", request);
    return request;
};

export const setPositionError = (error) => {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            console.error("User denied the request for Geolocation.");
            LogFirebase("LOCATION", "DENIED", "User denied the request for Geolocation.");
            break;
        case error.POSITION_UNAVAILABLE:
            LogFirebase("LOCATION", "DENIED", "Location information is unavailable.");
            console.error("Location information is unavailable.");
            break;
        case error.TIMEOUT:
            LogFirebase("LOCATION", "DENIED", "The request to get user location timed out.");
            console.error("The request to get user location timed out.");
            break;
        case error.UNKNOWN_ERROR:
            LogFirebase("LOCATION", "DENIED", "An unknown error occurred.");
            console.error("An unknown error occurred.");
            break;
    }
};

/* Convert bytes to MB */
export const bytesToMB = (bytes) => {
    return bytes / (1024 * 1024);
};

export const setLanguageObject = (language) => {
    PublicVariables.currentLanguageObj = language;
    if (!ENGLISH_LANGUAGE_CODES.includes(language.languageCode)) {
        document.body?.classList?.add("body-language-change");
    } else {
        document.body?.classList?.remove("body-language-change");
    }
    if (language.languageCode === JAPAN_LANGUAGE_CODE) {
        document.body?.classList?.add("japan-body");
    } else {
        document.body?.classList?.remove("japan-body");
    }
    if (language.languageCode === POLAND_LANGUAGE_CODE) {
        document.body?.classList?.add("body-poland");
    } else {
        document.body?.classList?.remove("body-poland");
    }
    updateVariableValue(language);
};

export const assignSupportLinkForBrowser = (msg) => {
    const localBrowserInfo = getExactBrowserName();
    const browserNameWithLowerCase = localBrowserInfo?.browserName?.toLowerCase();
    const { device_type } = msg;

    switch (device_type) {
        case "1":
            if (browserNameWithLowerCase === "chrome") {
                return HELP_ARTICLE.MOBILE_CHROME_ARTICLES_NUMBER;
            } else if (browserNameWithLowerCase === "samsung internet") {
                return HELP_ARTICLE.SAMSUNG_INTERNET_ARTICLES_NUMBER;
            } else {
                return HELP_ARTICLE.COMMON_ARTICLES_NUMBER;
            }
        case "2":
            return browserNameWithLowerCase === "safari" ? HELP_ARTICLE.SAFARI_MOBILE_TAB_ARTICLES_NUMBER : HELP_ARTICLE.COMMON_ARTICLES_NUMBER;

        case "3":
            switch (browserNameWithLowerCase) {
                case "chrome":
                    return HELP_ARTICLE.DESKTOP_CHROME_ARTICLES_NUMBER;
                case "firefox":
                    return HELP_ARTICLE.FIREFOX_ARTICLES_NUMBER;
                case "safari":
                    return HELP_ARTICLE.SAFARI_MAC_ARTICLES_NUMBER;
                default:
                    return HELP_ARTICLE.COMMON_ARTICLES_NUMBER;
            }

        case "4":
            return HELP_ARTICLE.ANDROID_APP_ARTICLES_NUMBER;

        case "5":
            return HELP_ARTICLE.IOS_APP_ARTICLES_NUMBER;

        default:
            return HELP_ARTICLE.COMMON_ARTICLES_NUMBER;
    }
};

export const deviceDetailsAllowed = () => {
    return PublicVariables.ldFlags?.captureDeviceAndGoogleEvent === true;
};

export const isSilentObserverAvailable = () => {
    if (CALL_DATA.isObserver) {
        document.body.classList.add("body-silent-observer");
        return true;
    } else {
        document.body.classList.remove("body-silent-observer");
        return false;
    }
};

export const isGuestAvailable = () => {
    if (GLOBAL_MEETING_DATA.isGuest) {
        document.body.classList.add("body-guest");
    } else {
        document.body.classList.remove("body-guest");
    }
};

export const addLogsForRedirectURL = () => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has(PARAMS.CLOSE_TAB)) {
        if (!isEmpty(searchParams.get(PARAMS.CLOSE_TAB))) {
            const paramsVal = searchParams.get(PARAMS.CLOSE_TAB);
            GLOBAL_MEETING_DATA.closetab = paramsVal;
            LogFirebase("_closetab", decodeURIComponent(paramsVal));
        }
    }
    if (searchParams.has(PARAMS.PLATFORM)) {
        if (!isEmpty(searchParams.get(PARAMS.PLATFORM))) {
            const paramsVal = searchParams.get(PARAMS.PLATFORM);
            GLOBAL_MEETING_DATA.platformName = paramsVal;
            LogFirebase("_platform", decodeURIComponent(paramsVal));
        }
    }
    if (searchParams.has(PARAMS.REDIRECT_URL)) {
        if (!isEmpty(searchParams.get(PARAMS.REDIRECT_URL))) {
            const paramsVal = searchParams.get(PARAMS.REDIRECT_URL);
            GLOBAL_MEETING_DATA.redirectUrl = paramsVal;
            LogFirebase("_redirect_url", decodeURIComponent(paramsVal));
        }
    }
};

export const loadDetectRTC = () => {
    return new Promise((resolve, reject) => {
        try {
            DetectRTC.load(() => {
                // Validate if DetectRTC properties are correctly loaded
                if (typeof DetectRTC.hasMicrophone === "undefined" || typeof DetectRTC.hasWebcam === "undefined") {
                    console.error("DetectRTC failed to load device information.");
                    return reject(new Error("DetectRTC failed to load device information."));
                }
                const result = {
                    browser: DetectRTC.browser,
                    hasMicrophone: DetectRTC.hasMicrophone,
                    hasWebcam: DetectRTC.hasWebcam,
                    isMobileDevice: DetectRTC.isMobileDevice,
                    osName: DetectRTC.osName,
                    osVersion: DetectRTC.osVersion,
                    version: DetectRTC.version,
                    fullBrowserVersion: DetectRTC.browser.fullVersion,
                    isWebsiteHasMicrophonePermissions: DetectRTC.isWebsiteHasMicrophonePermissions,
                    isWebsiteHasWebcamPermissions: DetectRTC.isWebsiteHasWebcamPermissions,
                    isCanvasSupportsStreamCapturing: DetectRTC.isCanvasSupportsStreamCapturing,
                    isGetUserMediaSupported: DetectRTC.isGetUserMediaSupported,
                    isCreateMediaStreamSourceSupported: DetectRTC.isCreateMediaStreamSourceSupported,
                    isVideoSupportsStreamCapturing: DetectRTC.isVideoSupportsStreamCapturing,
                    navigator: window.navigator.userAgent,
                };
                LogFirebase("DeviceDetails", "DetectRTC", result);
                resolve(result);
            });
        } catch (error) {
            console.error("Failed to load DetectRTC:", error.message);
            reject(new Error("An unexpected error occurred while loading DetectRTC: " + error.message));
        }
    });
};
